import { Cancel } from 'iconoir-react'
import React from 'react'
import NotificationCard from './NotificationCard'

const NotificationPanel = ({onPanelClose, notifications, onNewNotification}) => {
  return (
    <div className='h-screen z-50 p-5 shadow-lg md:w-1/4 w-1/2 border absolute right-0 bg-gray-50 shadow-slate-800'>
      <div className='flex items-center justify-between mb-2'>
        <div className='flex items-center space-x-5'>
          <h1 className=' text-lg font-bold text-gray-600'>Notifications</h1>
          <button onClick={onNewNotification} className='wayrideBgColor px-3 py-1 text-slate-100 rounded text-xs'>Create New</button>
        </div>
        <Cancel onClick={onPanelClose} className="cursor-pointer" />
      </div>
      <hr />
      <div className='py-2'>        
        {notifications && notifications.length > 0 ? 
          notifications.map((notification)=>{
            return <NotificationCard /> 
          }):
          <p className='text-gray-500 text-sm text-center mt-5 italic'>No new notification</p>
        }
      </div>
    </div>
  )
}

export default NotificationPanel